import React, { useState, useEffect, useRef } from 'react';

import awardImage from '../../../../assets/images/courses/team-players/award.png';
import cameraImage from '../../../../assets/images/courses/team-players/camera.png';
import chapterImg4 from '../../../../assets/images/courses/team-players/chapter5.2.1.jpg';
import chapterImg5 from '../../../../assets/images/courses/team-players/chapter5.6.1.jpg';
import chapterImg6 from '../../../../assets/images/courses/team-players/chapter5.6.2.jpg';
import chapterImg7 from '../../../../assets/images/courses/team-players/chapter5.6.3.png';
import chapterImg8 from '../../../../assets/images/courses/team-players/chapter5.6.4.png';
import dislikeImage from '../../../../assets/images/courses/team-players/dislike.png';
import maskImage from '../../../../assets/images/courses/team-players/mask.png';
import { CourseChapter } from '../../../../courses/courses.types';
import { CarouselComponent } from '../../CarouselComponent';
import { RatingTable, TopFiveResults } from '../../RoleCategory';
import { SliderInput } from '../../SliderInput';

interface TeamPlayersProps {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersChapter5: React.FC<TeamPlayersProps> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const [selectedSkill, setSelectedSkill] = useState('');
  const [ratings, setRatings] = useState<{ [key: string]: number } | null>(null);
  const columns = ['No Expirence', 'Beginning', 'Developing', 'Very Good'];
  const roleCategories = [
    {
      title: 'Strong work ethic',
      roles: [
        {
          name: '',
          description:
            'I have a strong work ethic and am committed to delivering high-quality work.',
        },
        {
          name: '',
          description:
            'I am willing to go above and beyond to ensure that tasks are completed on time and to the best of my ability.',
        },
      ],
    },
    {
      title: 'Excellent communication skills',
      roles: [
        {
          name: '',
          description:
            'I have excellent communication skills and can communicate clearly and effectively with colleagues, cliensm and stakeholders.',
        },
        {
          name: '',
          description:
            'I can listen actively and provide feedback in a constructive and respectful manner.',
        },
      ],
    },
    {
      title: 'Attention to details',
      roles: [
        {
          name: '',
          description:
            'I have a strong attention to details and can spot errors and inconsistencies quickly.',
        },
        {
          name: '',
          description: 'I can ensure that tasks are completed accurately and to a high standard.',
        },
      ],
    },
    {
      title: 'Ability to work under pressure',
      roles: [
        {
          name: '',
          description:
            'I can work well under pressure and can remain calm and focused in stressfull situtations.',
        },
        {
          name: '',
          description:
            'I can prioritize tasks effectively and meet deadlines even in high-pressure situations.',
        },
      ],
    },
    {
      title: 'Strong problem-solving skills',
      roles: [
        {
          name: '',
          description:
            'I have strong problem-solving skills and can identify issues and find effective solutions quickly and effectively',
        },
        {
          name: '',
          description:
            'I can think creatively and out side the box to find innovative solutions to complex problems.',
        },
      ],
    },
    {
      title: 'Positive attitude and outlook',
      roles: [
        {
          name: '',
          description:
            'I have a positive attitude and outlook and can maintain a can-do attitude even in challenging situations.',
        },
        {
          name: '',
          description:
            'I can motivate myself and others to achieve their goals and remain optimistics in the face of adversity',
        },
      ],
    },
    {
      title: 'Strong leadership skills',
      roles: [
        {
          name: '',
          description:
            'I have strong leadership skills and can inspire and motivate other to achieve their goals.',
        },
        {
          name: '',
          description:
            'I can provide direction and guidance to team members and can lead by example.',
        },
      ],
    },
    {
      title: 'Ability to adopt to change',
      roles: [
        {
          name: '',
          description: 'I can adapt to change quickly and effectively',
        },
        {
          name: '',
          description:
            'I can reamin flexible and open-minded in the face of new challenges and can adjust my approach as needed to achieve success.',
        },
      ],
    },
    {
      title: 'Excellent time management skills',
      roles: [
        {
          name: '',
          description:
            'I have excellent time management skills and can prioritize tasks effectively to meet deadlines.',
        },
        {
          name: '',
          description:
            'I can use time-blocking techniques and other productivity tools to ensure that I can complete tasks efficiently and effectively.',
        },
      ],
    },
    {
      title: 'Strong organizational skills',
      roles: [
        {
          name: '',
          description:
            'I have strong organizational skills and can keep track of multiple tasks and projects simultaneously.',
        },
        {
          name: '',
          description:
            'I can use project management tools and other organizational techniques to ensure that tasks are completed on time and to the best of my ability.',
        },
      ],
    },
    {
      title: 'Abitlity to work well in a team environment',
      roles: [
        {
          name: '',
          description:
            'I can work well in a team enivronment and can collaborate effectively with colleagues to achieve common goals.',
        },
        {
          name: '',
          description:
            'I can communicate clearly and respectfully with team members and can contribute my skills and expertise to achieve success',
        },
      ],
    },
    {
      title: 'Creative and innovative thinking',
      roles: [
        {
          name: '',
          description:
            'I have a creative and innovative approach to problem-solving and can think outside the box to find new solutions.',
        },
        {
          name: '',
          description: 'I can challenge assumptions and think critically to achieve success.',
        },
      ],
    },
    {
      title: 'Strong analytical skills',
      roles: [
        {
          name: '',
          description:
            'I have strong analytical skills and can analyze data and information to identify trends and insights.',
        },
        {
          name: '',
          description:
            'I can use this information to make informed decisions and drive business and achieve success.',
        },
      ],
    },
    {
      title: 'Excellent customer service skills',
      roles: [
        {
          name: '',
          description:
            'I have strong analytical skills and can analyze data and information to identify trends and insights.',
        },
        {
          name: '',
          description: 'I can use this information to make informed decisions and achieve success.',
        },
      ],
    },
    {
      title: 'Strong interpersonal skills',
      roles: [
        {
          name: '',
          description:
            'I have strong interpersonal skills and can build and maintain relationships with colleagues, clients, and stakeholders.',
        },
        {
          name: '',
          description:
            'I can communicate effectievly and respectfully and  can build trust and rapport with others.',
        },
      ],
    },
    {
      title: 'Ability to learn quickly and adapt to new situations',
      roles: [
        {
          name: '',
          description: 'I can learn quickly and adapt to new situations effectively.',
        },
        {
          name: '',
          description:
            'I can absorb new information and skills quickly and can apply them to achieve success.',
        },
      ],
    },
    {
      title: 'Strong technical skills',
      roles: [
        {
          name: '',
          description:
            'I have strong technical skills and can technology and software effectively to complete tasks and projects.',
        },
        {
          name: '',
          description:
            'I can stay up-to-date with new technologies and tools to ensure that I can achieve success.',
        },
      ],
    },
    {
      title: 'Ability  to multitask effectively',
      roles: [
        {
          name: '',
          description:
            'I can multitask effectively and can change manage multiple tasks and projects simultaneously.',
        },
        {
          name: '',
          description:
            'I can prioritize tasks effectively and can complete them efficiently and effectively.',
        },
      ],
    },
    {
      title: 'Strong decision-making skills',
      roles: [
        {
          name: '',
          description:
            'I have strong decision-making skills and can make informed decisions quickly and effectively.',
        },
        {
          name: '',
          description:
            'I can weigh pros and cons and consider all factors to make the best decision possible.',
        },
      ],
    },
    {
      title: 'Ability to take initative and be proactive',
      roles: [
        {
          name: '',
          description: 'I can take initiative and be proactive in the workplace.',
        },
        {
          name: '',
          description:
            'I can identify opportunities for improvement and take action to achieve success.',
        },
        {
          name: '',
          description:
            'I can take ownership of my work and can motivate myself and others to achieve their goals.',
        },
      ],
    },
  ];
  const slidesData = [
    {
      heading: 'Introduction',
      paragraph: `<p>Here's an intriguing exercise you can try, rate yourself out of 10 for three aspects.</p>`,
      list: [],
      image: chapterImg5,
    },
    {
      heading: 'What does your job require, out of 10?',
      paragraph: `<p>First, how much does your job demand from you? A score of 10 means it pushes you to your limits, while a 3 indicates it's easy to the point of boredom.</p>`,
      list: [],
      image: chapterImg6,
    },
    {
      heading: 'What’s your performance level out of 10?',
      paragraph: `<p>Next, assess your current performance level in that job. A 10 means you're performing at your best, while a 3 or lower suggests you're on the verge of being let go.</p>`,
      list: [],
      image: chapterImg7,
    },
    {
      heading:
        'What level of effort is within your comfort zone? Are you performing within, above, or below your comfort zone?',
      paragraph: `<p>Finally, consider the size of your comfort zone in relation to these factors. Are you performing comfortably within your zone, or are you pushing beyond it?</p>`,
      list: [],
      image: chapterImg8,
    },
  ];

  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };
  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSkill(event.target.value);
  };

  const handlePrints = (view: string) => {
    const printArea = document.getElementById(view);
    if (printArea) {
      printArea.classList.add('print-view');

      const cleanup = () => {
        printArea.classList.remove('print-view');
        window.onafterprint = null;
      };

      window.onafterprint = cleanup;

      window.print();
    }
  };
  const [openPopup, setOpenPopup] = useState<string | null>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setOpenPopup(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOpenPopup = (popupType: string) => {
    setOpenPopup(openPopup === popupType ? null : popupType);
  };

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Assessing & Using Your Teamwork Strengths</h2>
        <br />
        <p className="text-xl text-center font-light mt-10 mb-10">
          Identifying our strengths and weaknesses is an essential aspect of self-evaluation. It
          helps us understand ourselves better and allows us to develop strategies to improve our
          performance, especially when working with teams. Recognizing our strengths can boost our
          confidence and motivate us to achieve our goals.
        </p>
        <br />
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mb-1">Strengths Assessment</h3>
        <div className="p-6 bg-white rounded-lg shadow-md mb-6 mt-6">
          {ratings ? (
            <TopFiveResults
              ratings={ratings}
              roleCategories={roleCategories}
              onRetake={() => setRatings(null)}
            />
          ) : (
            <RatingTable
              roleCategories={roleCategories}
              onSubmit={setRatings}
              column={columns}
              firstColumn="Strength Skill Set"
            />
          )}
        </div>
        <h2 className="font-normal text-center text-2xl">
          Your strengths will make you a valuable team member. The next section will provide some
          helpful information to help you improve on those skills that you have not yet developed.
        </h2>
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mt-10 mb-10">Use Your Strengths</h3>
        <h2 className="font-normal text-center text-2xl">
          Do you ever find yourself holding back your strengths because of laziness or modesty?
          Well, once you know what you're good at, it's your job as a great team player to put those
          strengths to work. Look for any opportunity to contribute your skills.
        </h2>
        <div className="md:flex items-center mt-10 mb-10">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg4} alt="" />
          </div>
          <p className="flex-1 leading-7">
            <br />
            <br />
            According to Buckingham, a strength is not something that you're simply good at. A real
            strength is an activity that strengthens you internally, that you look forward to doing.
            It leaves you feeling energized rather than depleted.
          </p>
        </div>
        <p className="text-lg font-bold flex-1 mt-5 mb-5">
          A Gallup study found that focusing on strengths can lead to an almost 20% increase in
          performance and 73% lower attrition (employee turnover). We're simply happier, more
          confident, and more self-aware, not to mention more productive, when focusing on strengths
          rather than weaknesses.
        </p>
        <h3 className="text-2xl text-purple-600 font-bold mt-10 m-5">
          Activity: Strenergy Matrix{' '}
        </h3>
        <p className="text-lg font-bold flex-1 mt-5 mb-5">
          After you’ve identified your teamwork strengths, the next step is to figure out which of
          your true ‘Strengths’ to focus on using a matrix called the Strenergy Matrix. The matrix
          acts as a guide to determine which skills to invest in. on.
        </p>
        {/* Horizontal Line   ..................................................................................*/}
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            1
          </div>
        </div>
        <h3 className="text-xl  font-bold mt-10 m-5">Part 1:</h3>
        <p className="text-lg font-semibold flex-1 mt-5 mb-5">
          What do you believe are your strengths? List them below. Revisit the assessment above to
          obtain your list and add any other strengths you feel that you have in the{' '}
          <strong>Strengths Column </strong>below.
        </p>
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            2
          </div>
        </div>
        <h3 className="text-xl  font-bold mt-10 m-5">Part 2:</h3>
        <p className="text-lg font-semibold flex-1 mt-5 mb-5">
          Next you will work through each strength you’ve listed and ask yourself these two
          questions:
        </p>
        <ul className="list-decimal pl-7 mt-10 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">
            On a scale of 1 to 10, where 1 is lowest and 10 is highest, how energized do I feel when
            I think about this skill or apply this skill? (This determines whether it ‘strengthens’
            you)
          </li>
          <li className="pl-9 mb-7">
            Second, On a scale of 1 to 10, where 1 is not very good, and 10 is very good, how ‘good’
            am I at this skill? (This determines your proficiency)
          </li>
        </ul>
        <div id="print-view1">
          <table className="seek-information w-full">
            <thead>
              <tr>
                <th style={{ backgroundColor: 'blueviolet', color: 'whitesmoke' }}>Strength</th>
                <th style={{ backgroundColor: 'blueviolet', color: 'whitesmoke' }}>
                  "How energized do I feel when <br /> I think about this strength?"
                </th>
                <th style={{ backgroundColor: 'blueviolet', color: 'whitesmoke' }}>
                  "How 'good' am I at it?"
                </th>
              </tr>
            </thead>
            <tbody className="bg-purple-100">
              <tr>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
              </tr>
              <tr>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
                <td>
                  <textarea
                    className="w-full h-32 p-2 border rounded"
                    placeholder="Enter your text here..."
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="mt-5 text-right">
            <button onClick={() => handlePrints('print-view1')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <div id="print-view2" className="bg-gray-200 p-4 rounded-lg">
          <p className="text-xl font-light flex-1 mt-5 mb-5">
            Choose one collaboration skill from the following list and answer the question:
          </p>

          <ol className="list-decimal pl-5 mb-14 text-xl font-light">
            {[
              'Being creative',
              'Communicating well',
              'Being patient',
              'Working hard',
              'Being organized',
              'Bringing other people together',
            ].map((skill) => (
              <li key={skill} className="pl-9 mb-7 flex items-center">
                <input
                  type="radio"
                  name="collaborationSkill"
                  value={skill}
                  checked={selectedSkill === skill}
                  onChange={handleOptionChange}
                  className="mr-3 w-6 h-6 cursor-pointer"
                />
                {skill}
              </li>
            ))}
          </ol>

          <p className="text-xl font-light flex-1 mt-5 mb-5">
            How would the skill you choose be important on a team?
          </p>

          <textarea
            className="w-full bg-purple-300 h-32 p-2 border rounded"
            placeholder="Enter your text here..."
          ></textarea>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrints('print-view2')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            3
          </div>
        </div>
        <h3 className="text-xl  font-bold mt-10 m-5">Part 3:</h3>
        <p className="text-lg font-semibold flex-1 mt-5 mb-5">
          Based on your answers to the two questions, you then plot each skill into the matrix
          below. This map will help you better understand where your skills lie and how many of them
          are your true ‘strengths’.
        </p>
        {/* Image content pending */}
        <div className="graph-outer relative items-center">
          {/* <img src={chapterImg3} alt="" className='graph-position'/> */}
          <div className="graph-side-content">
            <span className="high-span">High</span>
            <h3 className="font-bold text-xl p-3 side-heading text-center">
              Proficiency <span className="font-light text-sm">(Am I Component?)</span>
            </h3>
            <span className="low-span">Low</span>
            <h3 className="font-bold text-xl p-3 bottom-heading text-center">
              strengthens me <span className="font-light text-sm">(Does this energize me?)</span>
            </h3>
          </div>
          <div className="graph-exterior relative">
            <span className="arrow-top arrow"></span>
            <div className="grid md:grid-cols-2 gap-4 graph-content">
              {/* Top Left */}
              <div className="bg-blue-100 border-right relative">
                <h3 className="font-bold text-base md:text-lg xl:text-xl p-3 md:min-h-[80px]">
                  Competent/Doesn't energize me.
                </h3>
                <textarea
                  className="w-full h-24 mt-2 p-2 border border-black placeholder-black"
                  placeholder="Type your response here"
                />
              </div>

              {/* Top Right */}
              <div className="bg-blue-100 relative">
                <h3 className="font-bold text-base md:text-lg xl:text-xl p-3 md:min-h-[80px]">
                  Competent/Energizes me.
                </h3>
                <textarea
                  className="w-full h-24 mt-2 p-2 border border-black placeholder-black"
                  placeholder="Type your response here"
                />
              </div>

              {/* Bottom Left */}
              <div className="bg-blue-100 border-right relative border-top">
                <h3 className="font-bold text-base md:text-lg xl:text-xl p-3 md:min-h-[80px]">
                  Not competent/Doesn't energize me.
                </h3>
                <textarea
                  className="w-full h-24 mt-2 p-2 border border-black placeholder-black"
                  placeholder="Type your response here"
                />
              </div>

              {/* Bottom Right */}
              <div className="bg-blue-100 relative border-top">
                <h3 className="font-bold text-base md:text-lg xl:text-xl p-3 md:min-h-[80px]">
                  Not competent/Energizes me.
                </h3>
                <textarea
                  className="w-full h-24 mt-2 p-2 border border-black placeholder-black"
                  placeholder="Type your response here"
                />
              </div>
            </div>
            <span className="arrow-bottom arrow"></span>
          </div>
        </div>
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            4
          </div>
        </div>
        <h3 className="text-xl  font-bold mt-10 m-5">Part 4:</h3>
        <p className="text-lg font-semibold flex-1 mt-5 mb-5">
          Based on where your strengths fall in the matrix, ask yourself these questions and enter
          your responses below each question. You can print your responses upon completion.
        </p>
        <div id="print-view3">
          <ol className="list-decimal pl-7 mb-14 text-xl font-light">
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                <strong>Bottom left quadrant:</strong> "How can I AVOID these tasks?"
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                <strong>Top left quadrant:</strong> "How can I DO LESS of these things?"
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                <strong>Bottom right quadrant:</strong> "How can I pursue this as a PASSION or HOBBY
                outside of work?"
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                <strong>Top right quadrant:</strong> "How can I DO MORE of these things?"
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
          </ol>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrints('print-view3')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <div>
          <h3 className="text-xl  font-bold mt-10 m-5">
            For helpful suggestions within each quadrant, click on the markers.
          </h3>
        </div>{' '}
        {/* Image content pending */}
        <div className="graph-outer relative items-center awarded-graph">
          <div className="graph-side-content">
            <span className="high-span">High</span>
            <h3 className="font-bold text-xl p-3 side-heading text-center">
              Proficiency <span className="font-light text-sm">(Am I Competent?)</span>
            </h3>
            <span className="low-span">Low</span>
            <h3 className="font-bold text-xl p-3 bottom-heading text-center">
              Strengthens Me <span className="font-light text-sm">(Does this energize me?)</span>
            </h3>
          </div>

          <div className="graph-exterior relative">
            <span className="arrow-top arrow"></span>
            <div className="grid md:grid-cols-2 gap-4 graph-content">
              {/* Top Left - Expandable */}
              <div className="border-right relative flex flex-col items-center justify-center mobile-border p-2">
                <div className="relative w-full">
                  <button
                    key="do-less"
                    className={`absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full text-gray-600 transition-all duration-300 ease-in-out
                      hover:shadow-[0_6px_16px_rgba(0,0,0,0.3)]
                      ${
                        openPopup === 'do-less'
                          ? 'bg-purple-500 text-white'
                          : 'bg-white shadow-[0_6px_16px_rgba(0,0,0,0.4)]'
                      }
                    `}
                    onClick={() => setOpenPopup(openPopup === 'do-less' ? null : 'do-less')}
                  >
                    +
                  </button>

                  {/* Popup inside div */}
                  {openPopup === 'do-less' && (
                    <div
                      ref={popupRef}
                      className="absolute top-0 right-12 bg-white p-4 z-50 rounded-lg graph-popup"
                    >
                      <span className="right-arrow-span"></span>
                      <h4 className="font-medium text-sm my-2">Top left quadrant - do less</h4>
                      <p className="text-xs font-light text-black my-2">
                        For tasks you’re not energized by but good at (which you may be doing a fair
                        bit at work), see if there are ways to delegate or minimize how much time
                        you spend on them. One suggestion is to get them out of the way in the
                        morning of your workday so you can enjoy the rest of your time.
                      </p>
                      <button
                        className="text-gray-600 mt-2 absolute top-0 right-2"
                        onClick={() => setOpenPopup(null)}
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
                <img src={dislikeImage} alt="" />
                <h4 className="font-medium text-base md:text-lg p-3 uppercase">Do Less</h4>
              </div>

              {/* Top Right */}
              <div className="flex flex-col items-center relative mobile-border justify-center p-2">
                <div className="relative w-full">
                  <button
                    key="do-more"
                    className={`absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full text-gray-600 transition-all duration-300 ease-in-out
                      hover:shadow-[0_6px_16px_rgba(0,0,0,0.3)]
                      ${
                        openPopup === 'do-more'
                          ? 'bg-purple-500 text-white'
                          : 'bg-white shadow-[0_6px_16px_rgba(0,0,0,0.4)]'
                      }
                    `}
                    onClick={() => setOpenPopup(openPopup === 'do-more' ? null : 'do-more')}
                  >
                    +
                  </button>

                  {/* Popup inside div */}
                  {openPopup === 'do-more' && (
                    <div
                      ref={popupRef}
                      className="absolute top-0 right-12 bg-white p-4 z-50 rounded-lg graph-popup"
                    >
                      <span className="right-arrow-span"></span>
                      <h4 className="font-medium text-sm my-2">Top right quadrant - do more</h4>
                      <p className="text-xs font-light text-black my-2">
                        For tasks you’re energized by and have a high proficiency or are competent
                        at, find out how you can do more of it! Speak to your boss and incorporate
                        it into your development plan.
                      </p>
                      <button
                        className="text-gray-600 mt-2 absolute top-0 right-2"
                        onClick={() => setOpenPopup(null)}
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
                <img src={awardImage} alt="" />
                <h4 className="font-medium text-base md:text-lg p-3 uppercase">Do More</h4>
              </div>

              {/* Bottom Left */}
              <div className="flex flex-col items-center border-right relative border-top mobile-border justify-center p-2">
                <div className="relative w-full">
                  <button
                    key="avoid"
                    className={`absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full text-gray-600 transition-all duration-300 ease-in-out
                      hover:shadow-[0_6px_16px_rgba(0,0,0,0.3)]
                      ${
                        openPopup === 'avoid'
                          ? 'bg-purple-500 text-white'
                          : 'bg-white shadow-[0_6px_16px_rgba(0,0,0,0.4)]'
                      }
                    `}
                    onClick={() => setOpenPopup(openPopup === 'avoid' ? null : 'avoid')}
                  >
                    +
                  </button>

                  {/* Popup inside div */}
                  {openPopup === 'avoid' && (
                    <div
                      ref={popupRef}
                      className="absolute top-0 right-12 bg-white p-4 z-50 rounded-lg graph-popup"
                    >
                      <span className="right-arrow-span"></span>
                      <h4 className="font-medium text-sm my-2">Bottom left quadrant - avoid</h4>
                      <p className="text-xs font-light text-black my-2">
                        For tasks you’re not energized by and not proficient at, you want to avoid
                        them. If your workday is filled with this sort of work, I hate to break it
                        to you, but you’re in the wrong role!
                      </p>
                      <button
                        className="text-gray-600 mt-2 absolute top-0 right-2"
                        onClick={() => setOpenPopup(null)}
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
                <img src={maskImage} alt="" />
                <h4 className="font-medium text-base md:text-lg p-3 uppercase">Avoid</h4>
              </div>

              {/* Bottom Right */}
              <div className="flex flex-col items-center relative border-top justify-center p-2">
                <div className="relative w-full">
                  <button
                    key="hobby"
                    className={`absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full text-gray-600 transition-all duration-300 ease-in-out
                      hover:shadow-[0_6px_16px_rgba(0,0,0,0.3)]
                      ${
                        openPopup === 'hobby'
                          ? 'bg-purple-500 text-white'
                          : 'bg-white shadow-[0_6px_16px_rgba(0,0,0,0.4)]'
                      }
                    `}
                    onClick={() => handleOpenPopup('hobby')}
                  >
                    +
                  </button>

                  {/* Popup inside div */}
                  {openPopup === 'hobby' && (
                    <div
                      ref={popupRef}
                      className="absolute top-0 right-12 bg-white p-4 z-50 rounded-lg graph-popup"
                    >
                      <span className="right-arrow-span"></span>
                      <h4 className="font-medium text-sm my-2">
                        Bottom right quadrant - keep as a hobby
                      </h4>
                      <p className="text-xs font-light text-black my-2">
                        For tasks you’re energized by but have low proficiency at, keep them as a
                        hobby or try to find ways to develop these skills.
                      </p>
                      <button
                        className="text-gray-600 mt-2 absolute top-0 right-2"
                        onClick={() => setOpenPopup(null)}
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
                <img src={cameraImage} alt="" />
                <h4 className="font-medium text-base md:text-lg p-3 uppercase">Keep as a Hobby</h4>
              </div>
            </div>
            <span className="arrow-bottom arrow"></span>
          </div>
        </div>
        <div className="relative flex items-center justify-center w-full mb-8 mt-8">
          <div className="w-full border-t border-gray-300"></div>
          <div
            className="absolute bg-purple-500 text-white font-bold flex items-center justify-center 
      w-10 h-10 rounded-full text-lg shadow-lg"
          >
            5
          </div>
        </div>
        <h3 className="text-xl  font-bold mt-10 m-5">Part 5: Commitments</h3>
        <p className="text-lg font-semibold flex-1 mt-5 mb-5">
          Complete the questions below. You can print your responses upon completion.
        </p>
        <div id="print-view4">
          <ol className=" pl-5 mb-14 text-xl font-light">
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                How will I apply these new insights into Practice?
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                How will I contribute my strengths at work for the sake of my team?
              </p>

              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
          </ol>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrints('print-view4')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <h3 className="text-2xl text-purple-600  font-bold mt-10 mb-5">
          Optional Activity: Explore your job, your comfort zone, and your potential
        </h3>
        <h3 className="text-2xl text-center font-normal mt-10 mb-5">
          It's crucial to understand yourself, but how do you improve that understanding? Seeking
          feedback is one way, and experimenting is another. Try taking on different roles within
          your team. Tackle tasks that you wouldn't typically do and see how you fare. Challenge
          yourself to step outside your comfort zone and attempt things that don't come easily to
          you—you might surprise yourself.
        </h3>
        <div className="border rounded-3xl mr-8">
          <CarouselComponent data={slidesData} isRequired={false} />
        </div>
        <h3 className="text-xl  font-bold mt-10 m-5">Here’s an example:</h3>
        <p className="text-lg font-light flex-1 mt-5 mb-5">
          If your comfort zone is an 8 and both your job demand and performance are at a 5, you
          might be coasting and could benefit from pushing yourself more. On the other hand, if your
          comfort zone is a 5, but your job and performance are both at an 8, and you're tackling
          big conference presentations, then you're really going above and beyond.
        </p>
        <h3 className="text-2xl text-purple-600 font-bold mt-10 m-5">Your Turn</h3>
        <div id="print-view5">
          <p className="text-lg font-bold flex-1 mt-5 mb-5">
            Part 1: Reflect on your current job. It could be volunteer work or paid work or on a
            school project. Take a moment to respond and rate these three numbers:
          </p>
          <ol className="list-decimal pl-7 mb-14 text-xl font-light">
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                What dose your job require, out of 10?
              </p>
              <SliderInput totalCount={10} />
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">What's your performance level?</p>

              <SliderInput totalCount={10} />
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                What level of effort is within you comfort zone? Are you performing within, above,
                or below your comfort zone?
              </p>

              <SliderInput totalCount={10} />
            </li>
          </ol>

          <div className="mt-5 text-right">
            <button onClick={() => handlePrints('print-view5')} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <p className="text-lg font-light flex-1 mt-5 mb-5">
          When we show up to the present moment with all of our senses, we invite the world to fill
          us with joy. The pains of the past are behind us. The future has yet to unfold. But the
          now is full of beauty simply waiting for our attention.
        </p>
        <br />
        <h3 className="text-2xl mt-10  text-center font-light mb-5">
          You might not have considered these challenges as positive before, but they likely are.
          The more you learn and grow, the better equipped you'll be to perform, both for yourself
          and for whatever team you find yourself in. Now let's look into assessing and managing
          your weaknesses.
        </h3>
        <br />
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Assessing & Managing Your Weaknesses
        </button>
      </div>
    </>
  );
};
